import React, {useState, useEffect, useRef, useMemo, useCallback} from "react";
import {toastr} from 'react-redux-toastr';
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import {FormGroup, Button, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Modal, Badge, Card, CardBody, CardTitle, CardHeader, CardFooter, Col, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Media, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Progress, Table, Container, Row, UncontrolledTooltip, Dropdown, } from "reactstrap";
import Header from "../../components/Headers/Header.jsx";
import generic_sort from "../../utils/generic_sort.js";
import general_fetch from "../../utils/fetch.js";
import { mkConfig, generateCsv, download } from "export-to-csv";
import Select from "react-select";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import makeAnimated from 'react-select/animated';
import { convert_to_readable } from "../../utils/convert_to_readable.js";
import OrgFilterModal from "../../components/OrgFilterModal/index.jsx";
import DateRangeModal from "../../components/DateRangeModal/index.jsx";
import { addDays } from "date-fns";
import mixpanel_event_types from "../../utils/mixpanel_event_types.js";
import NA from "../../components/NA/index.js";
import { pe_filter_options } from "../../utils/pe_helpers.js";
import fetch_mix_panel_data from "../../utils/fetch_mixpanel_data.js";
import filter_fn from "../../utils/org_filter_func.js";
import { colourStyles, colourStyles1 } from "../../utils/react_select_styles.js";
import { infurnia_add_ons } from "../../utils/infurnia_add_ons.js";
import ISearch from "../../components/ISearch/index.jsx";
import { get_csp_filter } from "../../utils/get_csp_filter.js";
import { set_csp_filter } from "../../utils/set_csp_filter.js";
import TablePagination from "../../components/TablePagination/index.jsx";
import { ITD, ITable, ITableBody, ITableRow } from "../../components/ITable/index.jsx";
import { date_string } from "../../utils/date_string.js";
import general_sort_for_orgs from "../../utils/general_sort_for_orgs.js";
import generic_sort_for_orgs from "../../utils/generic_sort_for_orgs.js";
import ChurnRemarkModal from "../../components/ChurnRemarkModal/index.js";
import { Checkbox, Tooltip, Switch } from 'antd';
import { get_non_internal_non_mes_user_count } from "../../utils/user_count.js";

const styles = {
	header_row: {
	  marginLeft: 0,
	  overflowX: "auto",
	},
	table_header: {
	  fontWeight: "bold",
	  fontSize: 'small'
	},
	round_status: {
	  fontSize: 'small',
	  paddingBottom: 0
	},
	nav_pills_rounds: {
	  paddingRight: 60,
	  marginRight: "0.7rem",
	  marginLeft: "0.2rem",
	},
	action_button: {
	  margin: 1       
	}
}; 

const animatedComponents = makeAnimated();

const ChurnedOrgs = ({all_stores, cs_org_users, user_details, activity_metadata, fetch_activity_metadata, fetch_all_stores, set_page_loader}) => {
	const [search_text, set_search_text] = useState('');
	const [stores, set_stores] = useState(null);
	const [original_stores, set_original_stores] = useState(null);
	const [current_page, set_current_page] = useState(1);
	const [page_size, set_page_size] = useState(50);
	const [no_of_pages, set_no_of_pages] = useState(null);
	const [premium_filter, set_premium_filter] = useState(true);
	const [enterprise_filter, set_enterprise_filter] = useState('');
	const [suspended_filter, set_suspended_filter] = useState('');
	const [internal_filter, set_internal_filter] = useState('');
    const [mes_expansion_filter, set_mes_expansion_filter] = useState('');
	const [se_filter, set_se_filter] = useState('');
	const [onboarding_filter, set_onboarding_filter] = useState('');
	const [churn_date_filter, set_churn_date_filter] = useState('');
	const [churn_date_from, set_churn_date_from] = useState('');
	const [churn_date_to, set_churn_date_to] = useState('');

	const [suspension_date_filter, set_suspension_date_filter] = useState('');
	const [suspension_date_from, set_suspension_date_from] = useState('');
	const [suspension_date_to, set_suspension_date_to] = useState('');

	const [due_date_filter, set_due_date_filter] = useState('');
	const [due_date_from, set_due_date_from] = useState('');
	const [due_date_to, set_due_date_to] = useState('');

	const [last_billed_date_filter, set_last_billed_date_filter] = useState('');
	const [last_billed_date_from, set_last_billed_date_from] = useState('');
	const [last_billed_date_to, set_last_billed_date_to] = useState('');

	const [filter_active, set_filter_active] = useState(true);
	const [cs_executives, set_cs_executives] = useState([]);
	const [usage_start_time, set_usage_start_time] = useState(addDays(new Date(new Date().toDateString()), -31));
	const [usage_end_time, set_usage_end_time] = useState(new Date(new Date().toDateString()));
	const [usage_duration_filter, set_usage_duration_filter] = useState('custom');
	const [mixpanel_org_level_events, set_mixpanel_org_level_events] = useState({});
	const [mixpanel_org_level_events_past, set_mixpanel_org_level_events_past] = useState({});
	const [selectedNavItem, set_selectedNavItem] = useState(4);
	const [show_date_range, set_show_date_range] = useState(false);
	const [show_usage_date_range, set_show_usage_date_range] = useState(false);
	const [selected_cses, set_selected_cses] = useState([]);
	const [ pe_filter, set_pe_filter ] = useState([]);
	const [selected_usage_events, set_selected_usage_events] = useState([{value: 'version_save', label: 'Version Save'}]);
	const [all_new_renewed_filter, set_all_new_renewed_filter] = useState('all');
	const [show_filter_modal, set_show_filter_modal] = useState(false);
	const [edited_cs_org_users, set_edited_cs_org_users] = useState();
	const initializedStateCount = useRef(0)
	const [filter_json_from_backend, set_filter_json_from_backend] = useState();
	const [responsiveness_filter, set_responsiveness_filter] = useState('');
	const [selected_add_ons, set_selected_add_ons] = useState('');
	const [selected_domains, set_selected_domains] = useState('');
	const [headings, set_headings] = useState()
	const [user_selected_page_size, set_user_selected_page_size] = useState(0);
	const [last_3_sorted_columns, set_last_3_sorted_columns] = useState([]);
	const [saved_last_3_sorted_columns, set_saved_last_3_sorted_columns] = useState([]);
	const [fetching_usage, set_fetching_usage] = useState(false);
	const [ payment_cycle_filter, set_payment_cycle_filter ] = useState('');
	const [ show_churn_remark_modal, set_show_churn_remark_modal ] = useState(false);
	const [ churn_modal_org_selected, set_churn_modal_org_selected ] = useState(null);
	const [ count_orgs_without_comment, set_count_orgs_without_comment ] = useState(0);
	const [ count_orgs_without_category, set_count_orgs_without_category ] = useState(0);
	const [ count_orgs_without_reachout_date, set_count_orgs_without_reachout_date ] = useState(0);
	const [usage_view_mode, set_usage_view_mode] = useState('custom');

	const [show_column_selector, set_show_column_selector] = useState(false);
    const createHeaders = (headings) => {
        return headings.map((item, idx) => ({
            ...item,
            ref: ('resizable-header' + item.column_name),
            }));
    }
    const columns = useMemo(() => headings ? createHeaders(headings) : [], [headings])
	const [searched_columns, set_searched_columns] = useState(columns);
    const [column_search_text, set_column_search_text] = useState('');

	const return_add_ons_string = (add_on_ids) => {
		let str = ''
		if(add_on_ids && add_on_ids.length){
			add_on_ids = add_on_ids.map((x, idx) => infurnia_add_ons.find(o => o.value === x)?infurnia_add_ons.find(o => o.value === x).label:'').sort()
			add_on_ids.map((x, idx) => str = str + (idx!=0 ? ', ' : '') + x, '')
		}
		return str
	}

	const get_sort_order = (column_name) => {
		return last_3_sorted_columns && last_3_sorted_columns.length && last_3_sorted_columns[last_3_sorted_columns.length-1].column_name === column_name ? last_3_sorted_columns[last_3_sorted_columns.length-1].order : false
	}

    const get_contact = (store) => {
        let contact = '';
        if(store.poc_number && store.poc_name) {
            contact = `${store.poc_name} | ${formatPhoneNumberIntl(store.poc_number)}`
        } else if(store.poc_name) {
            contact = store.poc_name
        } else if(store.poc_number) {
            contact = formatPhoneNumberIntl(store.poc_number)
        }
        return contact
    }

	const tenPointMetrics = useMemo(() => [
		{ key: 'Design', value: 'version_save' },
		{ key: 'Render', value: 'render' },
		{ key: 'Presentation', value: 'presentation_usage' },
		{ key: 'Pricing Quotation', value: 'pricing_quotation_download' },
		{ key: 'Published Panels', value: 'MES Panel Listed' },
		{ key: 'Cutlist', value: 'cutlist_output_download' },
		{ key: 'Board Layout', value: 'board_layout_download' },
		{ key: 'Panel Labels', value: 'labels_download' },
		{ key: 'CAM Output', value: 'cam_output_download' },
		{ key: 'Packaged Panels', value: 'Panel Packaged' }
	], []);

	const getMetricValue = useCallback((orgId, metricValue) => {
		try {
			if (mixpanel_org_level_events && 
				orgId && 
				mixpanel_org_level_events[orgId] && 
				metricValue) {
				const value = mixpanel_org_level_events[orgId][metricValue];
				if (typeof value === 'number' || (value && !isNaN(Number(value)))) {
					return typeof value === 'number' ? value : Number(value);
				}
			}
			return 0;
		} catch (error) {
			console.error("Error getting metric value:", error, "for", metricValue);
			return 0;
		}
	}, [mixpanel_org_level_events]);

	const main_headings = useMemo(() => {
		const baseHeadings = [
			{
				column_name: 'Manage',
				styles:{position:"sticky", top:0, left:0, zIndex:3, backgroundColor:'white'},
				sort_fn: () => {},
				columnWidth: 'minmax(60px, 60px)'
			},
			{
				column_name: 'No.',
				styles:{position:'sticky', top:0, left: '60px', zIndex: 3, backgroundColor:'white'},
				sort_fn: () => {},
				columnWidth: 'minmax(60px, 60px)'
			},
			{
				column_name: 'Org Name',
				styles:{position:'sticky', top:0, left: '120px', zIndex: 3, backgroundColor:'white', whiteSpace: 'normal', lineHeight: '1.2', height: 'auto', wordWrap: 'break-word', padding: '4px'},
				show_sort:true,
				show_sort_order: get_sort_order('Org Name'),
				sort_fn: () => general_sort_for_orgs('Org Name', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				columnWidth: 'minmax(200px, 2fr)'
			},
			{
				column_name: 'Add-ons',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort_order: get_sort_order( 'Add-ons'),
				sort_fn: () => general_sort_for_orgs( 'Add-ons', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort:true,
				columnWidth:'minmax(150px, 2fr)'
			},
			{
				column_name: 'Users',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort_order: get_sort_order( 'Users'),
				sort_fn: () => general_sort_for_orgs( 'Users', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort:true,
				columnWidth:'minmax(100px, 2fr)'
			},
			{
				column_name: 'Churn Comment',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort_order: get_sort_order( 'Churn Comment'),
				sort_fn: () => general_sort_for_orgs( 'Churn Comment', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				// show_sort: true,
				columnWidth:'minmax(300px, 2fr)'
			},
			{
				column_name: 'Churn Category',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort_order: get_sort_order( 'Churn Category'),
				sort_fn: () => general_sort_for_orgs( 'Churn Category', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort: true,
				columnWidth:'minmax(275px, 2fr)'
			},
			{
				column_name: 'Churn R/o Date',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				sort_fn: () => {},
				columnWidth:'minmax(150px, 2fr)'
			},
			{
				column_name: 'Org ID',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort: true,
				show_sort_order: get_sort_order('Org ID'),
				sort_fn: () => general_sort_for_orgs('Org ID', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				columnWidth:'minmax(200px, 2fr)'
			},
			{
				column_name: 'Churn Date',
				styles:{position:'sticky', top:0, backgroundColor:'white', zIndex:1},
				show_sort_order: get_sort_order( 'Churn Date'),
				sort_fn: () => general_sort_for_orgs( 'Churn Date', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort: true,
				columnWidth:'minmax(150px, 2fr)'
			},
		];
		
		// Add common multiline styling to all headers
		const multilineHeaderStyle = {
			whiteSpace: 'normal', 
			lineHeight: '1.2', 
			height: 'auto', 
			wordWrap: 'break-word',
			padding: '4px'
		};

		// Apply multiline styling to all column headers except the first two navigation columns
		for (let i = 2; i < baseHeadings.length; i++) {
			baseHeadings[i].styles = {
				...baseHeadings[i].styles,
				...multilineHeaderStyle
			};
		}
		
		if (usage_view_mode === 'custom') {
			baseHeadings.splice(10, 0, {
				column_name: 'Usage',
				styles:{
					position:'sticky', 
					top:0, 
					backgroundColor:'white', 
					zIndex:1,
					...multilineHeaderStyle
				},
				show_sort_order: get_sort_order('Usage'),
				sort_fn: () => general_sort_for_orgs('Usage', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort: true,
				columnWidth:'minmax(120px, 2fr)'
			},
			{
				column_name: 'Usage Change',
					styles:{
					position:'sticky', 
					top:0, 
					backgroundColor:'white', 
					zIndex:1,
					...multilineHeaderStyle
				},
				show_sort_order: get_sort_order('Usage Change'),
				sort_fn: () => general_sort_for_orgs('Usage Change', last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort: true,
				columnWidth:'minmax(140px, 2fr)'
			});
		} else {
			const tenPointColumns = tenPointMetrics.map(metric => ({
				column_name: metric.key,
					styles:{
					position:'sticky', 
					top:0, 
					backgroundColor:'white', 
					zIndex:1,
					...multilineHeaderStyle
				},
				show_sort_order: get_sort_order(metric.key),
				sort_fn: () => general_sort_for_orgs(metric.key, last_3_sorted_columns, set_last_3_sorted_columns, stores, set_stores, sorting_function_value),
				show_sort: true,
				columnWidth:'105px'
			}));
			
			// Find the index of the Users column and insert the 10-point metrics after it
			const usersIndex = baseHeadings.findIndex(h => h.column_name === 'Users');
			if (usersIndex !== -1) {
				baseHeadings.splice(usersIndex + 1, 0, ...tenPointColumns);
			} else {
				// Fallback to the original position if Users column isn't found
				baseHeadings.splice(10, 0, ...tenPointColumns);
			}
		}
		
		return baseHeadings;
	}, [stores, tenPointMetrics, usage_view_mode, last_3_sorted_columns]);

	const [column_visibility_json, set_column_visibility_json] = useState(() => {let json = {}; main_headings.map(col => {json[col.column_name] = 1}); return json});

	useEffect(() => {
		set_headings(main_headings)
	}, [main_headings]);

	useEffect(() => {
		if (usage_view_mode === 'custom') {
			column_visibility_json['Usage'] = true;
			column_visibility_json['Usage Change'] = true;
			tenPointMetrics.forEach(metric => {
				column_visibility_json[metric.key] = false;
			});
		} else {
			column_visibility_json['Usage'] = false;
			column_visibility_json['Usage Change'] = false;
			tenPointMetrics.forEach(metric => {
				column_visibility_json[metric.key] = true;
			});
		}
		set_column_visibility_json({...column_visibility_json});
	}, [usage_view_mode, tenPointMetrics]);

	const TableData = useCallback((store, idx, current_page, page_size) => {
		const baseData = {
			'Manage': <ITD style={{ position: 'sticky', left: 0, backgroundColor: 'white', zIndex:'2'}} className='text-center' ><Link to={"/home/store_dashboard/" + store.id + '/7'} target="_blank"><i className="fa fa-cog" color="primary" style={{ fontSize: '18px' }} /></Link></ITD>,
			'No.': <ITD style={{ position: 'sticky', left: '60px', backgroundColor: 'white', zIndex:'2'}} title={store.idx ? store.idx : ''} className="ITD_style">{((current_page - 1) * page_size) + idx + 1}</ITD>,
			'Org Name': <ITD style={{ position: 'sticky', left: '120px', backgroundColor: 'white', zIndex:'2'}} title={store.name ? store.name : ''} className="ITD_style">{store.name ? store.name : <NA />}</ITD>,
			'Add-ons': <ITD>{store.active_add_on_ids && store.active_add_on_ids.length ? return_add_ons_string(store.active_add_on_ids) : <NA/>}</ITD>,
			'Users': <ITD className="text-right">{get_non_internal_non_mes_user_count(store.users)}</ITD>,
			'Churn Comment': <ITD onClick={trigger_churn_remark_modal(store)} style={{ cursor: 'pointer' }} title={store.latest_cse_remark ? store.latest_cse_remark : ''}>{store.latest_cse_remark ? store.latest_cse_remark : <NA />}</ITD>,
			'Churn Category': <ITD onClick={trigger_churn_remark_modal(store)} style={{ cursor: 'pointer' }}>{(store.latest_cse_remark_metadata && store.latest_cse_remark_metadata.reason) ? store.latest_cse_remark_metadata.reason + (store.latest_cse_remark_metadata.sub_reason ? ' :: ' + store.latest_cse_remark_metadata.sub_reason : '') : <NA />}</ITD>,
			'Churn R/o Date': <ITD onClick={trigger_churn_remark_modal(store)} style={{ cursor: 'pointer' }}>{(store.latest_cse_remark_metadata && store.latest_cse_remark_metadata.reachout_date) ? new Date(store.latest_cse_remark_metadata.reachout_date).toString().substring(4, 15) : <NA />}</ITD>,
			'Org ID': <ITD style={{textTransform: 'lowercase', }}>{store.id ? store.id : <NA />}</ITD>,
			'Churn Date': <ITD>{store.churn_date ? new Date(store.churn_date).toString().substring(4, 15) : <NA />}</ITD>,
		};
		
		if (usage_view_mode === 'custom') {
			baseData['Usage'] = <ITD className="text-right">{mixpanel_org_level_events && mixpanel_org_level_events[store.id] && selected_usage_events.length ? selected_usage_events.reduce((final, event) => mixpanel_org_level_events[store.id][event.value] ? final + mixpanel_org_level_events[store.id][event.value] : final, 0).toLocaleString() : "0"}</ITD>;
			baseData['Usage Change'] = <ITD className="text-right">{usage_change(store.id)}</ITD>;
		} else {
			tenPointMetrics.forEach(metric => {
				const metricValue = getMetricValue(store.id, metric.value);
				baseData[metric.key] = (
					<ITD className="text-right" title={`${metric.key}: ${metric.value}`}>
						{metricValue.toLocaleString()}
					</ITD>
				);
			});
		}
		
		return {
			...baseData,
			'Next Billing': <ITD>{store.next_billing_date ? new Date(store.next_billing_date).toString().substring(4, 15) : <NA />}</ITD>,
			'Last Billing': <ITD>{store.last_billing_date ? new Date(store.last_billing_date).toString().substring(4, 15) : <NA />}</ITD>,
			'Start Date': <ITD>{store.license_start_date ? new Date(store.license_start_date).toString().substring(4, 15) : <NA />}</ITD>,
			'Closing Date': <ITD>{store.closing_date ? new Date(store.closing_date).toString().substring(4, 15) : <NA />}</ITD>,
			'Billing Mails': <ITD>{store.billing_mailing_enabled ? 'enabled' : 'disabled'}</ITD>,
			'MES Expansion': <ITD>{store.csp_important ? 'Yes' : 'No'}</ITD>,
			'Last Activity': <ITD>{activity_metadata && activity_metadata[store.id] && activity_metadata[store.id].last_activity ? date_string(activity_metadata[store.id].last_activity.due_date) : <NA />}</ITD>,
			'Next Activity': <ITD>{activity_metadata && activity_metadata[store.id] && activity_metadata[store.id].next_activity ? date_string(activity_metadata[store.id].next_activity.due_date) : <NA />}</ITD>,
			'Contact': <ITD>{store && get_contact(store) ? get_contact(store) : <NA />}</ITD>,
			'Onboarding': <ITD>{store.onboarding_status ? store.onboarding_status : <NA />}</ITD>,
			'Domain': <ITD>{store.domain ? store.domain : <NA/>}</ITD>,
			'Enterprise': <ITD>{store.enterprise ? 'Enterprise' : 'SMB'}</ITD>,
			'Activity Count': <ITD>{activity_metadata && activity_metadata[store.id] ? activity_metadata[store.id].activity_count : <NA />}</ITD>,
			'CS Rep': <ITD>{store.customer_success_executive_name ? store.customer_success_executive_name : <NA />}</ITD>,
		};
	}, [stores, mixpanel_org_level_events, mixpanel_org_level_events_past, selected_usage_events, activity_metadata, tenPointMetrics, usage_view_mode, getMetricValue]);

	const sorting_function_value = (store) => {
		const baseValues = {
			'Org Name': {value:store.name ? store.name.toLowerCase() : '', field_type:'string'},
			'Org ID': {value:store.id ? store.id.toLowerCase() : '', field_type:'string'},
		};
		
		// Add safety check for all columns to prevent undefined errors
		try {
			if (usage_view_mode === 'custom') {
				baseValues['Usage'] = {
					value: mixpanel_org_level_events && mixpanel_org_level_events[store.id] && selected_usage_events.length ? 
						selected_usage_events.reduce((final, event) => mixpanel_org_level_events[store.id][event.value] ? 
							final + mixpanel_org_level_events[store.id][event.value] : final, 0) : 0, 
					field_type: 'number'
				};
				baseValues['Usage Change'] = {
					value: Number((usage_change(store.id) || "0").replace('%', '')), 
					field_type: 'number'
				};
			} else {
				// Add 10-point metrics with safety checks
				tenPointMetrics.forEach(metric => {
					baseValues[metric.key] = {
						value: getMetricValue(store.id, metric.value),
						field_type: 'number'
					};
				});
			}
		} catch (err) {
			console.error("Error in sorting function:", err);
		}
		
		// Ensure all required columns exist to prevent sorting errors
		if (usage_view_mode === 'custom') {
			if (!baseValues['Usage']) {
				baseValues['Usage'] = {value: 0, field_type: 'number'};
			}
			if (!baseValues['Usage Change']) {
				baseValues['Usage Change'] = {value: 0, field_type: 'number'};
			}
		} else {
			tenPointMetrics.forEach(metric => {
				if (!baseValues[metric.key]) {
					baseValues[metric.key] = {value: 0, field_type: 'number'};
				}
			});
		}
		
		return {
			...baseValues,
			'Onboarding': {value:store.onboarding_status ? store.onboarding_status :'', field_type:'string'},
			'Add-ons': {value:store.active_add_on_ids && store.active_add_on_ids.length ? return_add_ons_string(store.active_add_on_ids) :'', field_type:'string'},
			'Domain': {value:store.domain ? store.domain :'', field_type:'string'},
			'Users': {value:get_non_internal_non_mes_user_count(store.users), field_type:'number'},
			'Billing Mails': {value:store.billing_mailing_enabled ? 'enabled' : 'disabled', field_type:'string'},
			'MES Expansion': {value:store.csp_important ? 'Yes' : 'No', field_type:'string'},
			'Churn Date': {value:store.churn_date ? new Date(store.churn_date) : '', field_type:'date'},
			'Last Activity': {value:activity_metadata && activity_metadata[store.id] && activity_metadata[store.id].last_activity ? date_string(activity_metadata[store.id].last_activity.due_date) :'', field_type:'date'},
			'Next Activity': {value:activity_metadata && activity_metadata[store.id] && activity_metadata[store.id].next_activity ? date_string(activity_metadata[store.id].next_activity.due_date) :'', field_type:'date'},
			'Contact': {value: store ? get_contact(store) : '', field_type:'string'},
			'Next Billing': {value:store.next_billing_date ? new Date(store.next_billing_date):'', field_type:'date'},
			'Last Billing': {value:store.last_billing_date ? new Date(store.last_billing_date):'', field_type:'date'},
			'Start Date': {value:store.license_start_date ? new Date(store.license_start_date):'', field_type:'date'},
			'Closing Date': {value:store.closing_date ? new Date(store.closing_date):'', field_type:'date'},
			'Enterprise': {value:store.enterprise ? 'Enterprise' : 'SMB', field_type:'string'},
			'Activity Count': {value:activity_metadata && activity_metadata[store.id] ? activity_metadata[store.id].activity_count :0, field_type:'number'},
			'CS Rep': {value:store.customer_success_executive_name ? store.customer_success_executive_name:'', field_type:'string'},
			'Churn Comment': {value:store.latest_cse_remark ? store.latest_cse_remark:'', field_type:'string'},
			'Churn Category': {value:(store.latest_cse_remark_metadata && store.latest_cse_remark_metadata.reason) ? store.latest_cse_remark_metadata.reason + (store.latest_cse_remark_metadata.sub_reason ? ' :: ' + store.latest_cse_remark_metadata.sub_reason : '') :'', field_type:'string'},
		};
	};

	const download_overview_csv = () => {
		try {
			let csv_stores = stores.map(store => {
				let store_json = {}
				if(column_visibility_json['Org ID']) store_json['Org ID'] = store.id
				if(column_visibility_json['Org Name']) store_json['Org Name'] = store.name
				
				if (usage_view_mode === 'custom') {
					if(column_visibility_json['Usage']) store_json['Usage'] = mixpanel_org_level_events && mixpanel_org_level_events[store.id] && selected_usage_events.length ? selected_usage_events.reduce((final, event) => mixpanel_org_level_events[store.id][event.value] ? final + mixpanel_org_level_events[store.id][event.value] : final, 0).toLocaleString() : "0"
					if(column_visibility_json['Usage Change']) store_json['Usage Change'] = usage_change(store.id)
				} else {
					tenPointMetrics.forEach(metric => {
						if(column_visibility_json[metric.key]) {
							store_json[metric.key] = getMetricValue(store.id, metric.value).toLocaleString();
						}
					});
				}
				
				if(column_visibility_json['Onboarding']) store_json['Onboarding'] = store.onboarding_status ? store.onboarding_status : ''
				if(column_visibility_json['Add-ons']) store_json['Add-ons'] = store.active_add_on_ids && store.active_add_on_ids.length ? return_add_ons_string(store.active_add_on_ids) : ''
				return store_json
			})
			const csvConfig = mkConfig({ useKeysAsHeaders: true });
			const csv = generateCsv(csvConfig)(csv_stores);
			download(csvConfig)(csv)
		} catch (e) {
			console.error(e)
			toastr.error(`Couldn't download overview CSV`)
		}
	}

	useEffect(() => {
		if(all_stores && all_stores.length){
			refresh_data();
		}
	}, [all_stores]);

	useEffect(() => {
		if(cs_org_users && cs_org_users.length && user_details){
			fetch_cs_org_users()
		}
	}, [cs_org_users, user_details]);

	useEffect(() => {
		filter_fn(search_text, original_stores, set_stores, selectedNavItem, all_new_renewed_filter, enterprise_filter, suspended_filter, internal_filter, mes_expansion_filter, selected_cses, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, churn_date_filter, churn_date_from, churn_date_to, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, payment_cycle_filter, undefined, pe_filter)
	}, [search_text, original_stores, selectedNavItem, all_new_renewed_filter, due_date_filter, suspension_date_filter, churn_date_filter, last_billed_date_filter, payment_cycle_filter]);

	useEffect(() => {
		if(all_stores && all_stores.length) fetch_activity_metadata()
	}, []);

	useEffect(() => {
		if (usage_duration_filter && usage_duration_filter != 'custom') {
			let from_date = new Date(), to_date = new Date()
			if (usage_duration_filter == 'yesterday') {
				from_date = new Date(new Date().toDateString())
				to_date = new Date(new Date().toDateString())
				from_date.setDate(from_date.getDate() - 1)
			} else if (usage_duration_filter == 'last_7_days') {
				from_date.setDate(from_date.getDate() - 7)
			} else if (usage_duration_filter == 'last_30_days') {
				from_date.setDate(from_date.getDate() - 30)
			}else if(usage_duration_filter == 'today') {
				from_date = new Date(new Date().toDateString())
			}
			fetch_mix_panel_data(from_date, to_date, set_mixpanel_org_level_events, set_mixpanel_org_level_events_past, set_fetching_usage)
		}
	}, [usage_duration_filter]);

	useEffect(() => {
		if(enterprise_filter != '' || internal_filter != '' || mes_expansion_filter != '' || (selected_cses && selected_cses.length) || (pe_filter && pe_filter.length) || se_filter != '' || onboarding_filter != '' || responsiveness_filter != '' || payment_cycle_filter || (selected_add_ons && selected_add_ons.length) || (selected_domains && selected_domains.length)) {
			set_filter_active(true)
		}else{
			set_filter_active(false)
		}
	}, [enterprise_filter, internal_filter, mes_expansion_filter, selected_cses, pe_filter, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, payment_cycle_filter]);
	
	useEffect(() => {
		console.log('all uef', initializedStateCount.current)
		if(initializedStateCount.current < 2){
			initializedStateCount.current += 1
		}else if(user_details && user_details.id){
			let filter_json = {
				selectedNavItem, search_text, internal_filter, mes_expansion_filter, 
				enterprise_filter, selected_cses, pe_filter, se_filter, onboarding_filter, 
				responsiveness_filter, selected_add_ons, selected_domains, 
				all_new_renewed_filter, selected_usage_events, churn_date_filter, 
				churn_date_from, churn_date_to, usage_duration_filter, 
				usage_start_time, usage_end_time, column_visibility_json, 
				user_selected_page_size, payment_cycle_filter, usage_view_mode
			}
			if(last_3_sorted_columns && last_3_sorted_columns.length){
				filter_json['last_3_sorted_columns'] = last_3_sorted_columns
			}else{
				filter_json['last_3_sorted_columns'] = saved_last_3_sorted_columns
			}
			set_csp_filter(user_details.id, '/home/churned_orgs', '0', filter_json)
		}
	}, [user_details, selectedNavItem, search_text, internal_filter, mes_expansion_filter, enterprise_filter, selected_cses, pe_filter, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, all_new_renewed_filter, selected_usage_events, churn_date_filter, churn_date_from, churn_date_to, usage_duration_filter, usage_start_time, usage_end_time, column_visibility_json, user_selected_page_size, payment_cycle_filter, last_3_sorted_columns, usage_view_mode]);

	useEffect(() => {
		if(user_details && user_details.id) get_csp_filter(user_details.id, '/home/churned_orgs', set_filter_json_from_backend)
	}, [user_details]);

	useEffect(() => {
		if (stores && stores.length && !user_selected_page_size) {
			let x1 = document.getElementById('orgs_page_header').offsetHeight
			let x2 = 52
			let x3 = 45
			let remaining_height = window.innerHeight - x1 - x2 - x3
			let page_size1 = Math.floor(remaining_height/45)
			set_page_size(page_size1)
			console.log('no of pages', remaining_height, no_of_pages, stores.length)
		}
	}, [stores]);

	useEffect(() => {
		if(stores && stores.length){
			var pages = Math.floor((stores.length / page_size)) + ((stores.length % page_size) ? 1 : 0)
			set_no_of_pages(pages)
			set_count_orgs_without_comment(stores.filter(x => !x.latest_cse_remark).length);
			set_count_orgs_without_category(stores.filter(x => !x.latest_cse_remark_metadata || !x.latest_cse_remark_metadata.reason).length);
			set_count_orgs_without_reachout_date(stores.filter(x => !x.latest_cse_remark_metadata || !x.latest_cse_remark_metadata.reachout_date).length);
			console.log('count_orgs_without_comment', count_orgs_without_comment, count_orgs_without_category, count_orgs_without_reachout_date);
		}else{
			set_no_of_pages(1)
		}
		set_current_page(1)
	}, [page_size, stores]);

	useEffect(() => {
		if(filter_json_from_backend && filter_json_from_backend['/home/churned_orgs'] && original_stores && original_stores.length){
			let final_json = JSON.parse(filter_json_from_backend['/home/churned_orgs'][0])
			console.log('Response data cassandra1234 all uef', final_json)
			if(final_json){
				set_selectedNavItem(final_json.selectedNavItem)
				set_search_text(final_json.search_text ? final_json.search_text : '')
				set_internal_filter(final_json.internal_filter ? final_json.internal_filter : '')
                set_mes_expansion_filter(final_json.mes_expansion_filter ? final_json.mes_expansion_filter : '')
				set_enterprise_filter(final_json.enterprise_filter ? final_json.enterprise_filter : '')
				set_selected_cses(final_json.selected_cses ? final_json.selected_cses : [])
				set_pe_filter(final_json.pe_filter ? final_json.pe_filter : [])
				set_se_filter(final_json.se_filter ? final_json.se_filter : '')
				set_onboarding_filter(final_json.onboarding_filter ? final_json.onboarding_filter : '')
				set_responsiveness_filter(final_json.responsiveness_filter ? final_json.responsiveness_filter : '')
				set_selected_add_ons(final_json.selected_add_ons)
				set_selected_domains(final_json.selected_domains)
				set_all_new_renewed_filter(final_json.all_new_renewed_filter)
				set_selected_usage_events(final_json.selected_usage_events)
				set_churn_date_filter(final_json.churn_date_filter)
				set_churn_date_from(new Date(final_json.churn_date_from))
				set_churn_date_to(new Date(final_json.churn_date_to))
				set_usage_duration_filter(final_json.usage_duration_filter)
				set_usage_start_time(new Date(final_json.usage_start_time))
				set_usage_end_time(new Date(final_json.usage_end_time))
				set_user_selected_page_size(Number(final_json.user_selected_page_size))
				set_usage_view_mode(final_json.usage_view_mode || 'custom')
				if(Number(final_json.user_selected_page_size)){
					set_user_selected_page_size(Number(final_json.user_selected_page_size))
					set_page_size(Number(final_json.user_selected_page_size))
				}
				if(final_json.column_visibility_json){
					main_headings.map((key) => {
						if(final_json.column_visibility_json[key.column_name] || final_json.column_visibility_json[key.column_name]==undefined){
							column_visibility_json[key.column_name] = true
						}else{
							column_visibility_json[key.column_name] = false
						}
					})
				}
				if(final_json.usage_duration_filter && final_json.usage_duration_filter==='custom'){
					fetch_mix_panel_data(new Date(final_json.usage_start_time), new Date(final_json.usage_end_time), set_mixpanel_org_level_events, set_mixpanel_org_level_events_past, set_fetching_usage)
				}else if(!final_json.usage_duration_filter){
					fetch_mix_panel_data(new Date(usage_start_time), new Date(usage_end_time), set_mixpanel_org_level_events, set_mixpanel_org_level_events_past, set_fetching_usage)
				}
				
				if(final_json.last_3_sorted_columns && final_json.last_3_sorted_columns.length){
					set_saved_last_3_sorted_columns(final_json.last_3_sorted_columns)
					set_last_3_sorted_columns(final_json.last_3_sorted_columns)
				}

				filter_fn(final_json.search_text, original_stores, set_stores, final_json.selectedNavItem, final_json.all_new_renewed_filter, final_json.enterprise_filter, suspended_filter, final_json.internal_filter, final_json.mes_expansion_filter, final_json.selected_cses, final_json.se_filter, final_json.onboarding_filter, final_json.responsiveness_filter, final_json.selected_add_ons, final_json.selected_domains, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, final_json.churn_date_filter, final_json.churn_date_from, final_json.churn_date_to, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, final_json.payment_cycle_filter, undefined, final_json.pe_filter)
			}
		}
	}, [filter_json_from_backend, original_stores]);

	useEffect(() => {
		if(saved_last_3_sorted_columns && saved_last_3_sorted_columns.length && original_stores && original_stores.length && mixpanel_org_level_events && mixpanel_org_level_events_past && cs_org_users && cs_org_users.length){
			let temp_stores = JSON.parse(JSON.stringify(stores));
			saved_last_3_sorted_columns.map(column => {
				let order = column.order==='asc' ? 1 : -1
				temp_stores = generic_sort_for_orgs(column.column_name, temp_stores, order, sorting_function_value)
			})
			set_stores(temp_stores)
		}
	}, [saved_last_3_sorted_columns, original_stores, mixpanel_org_level_events, mixpanel_org_level_events_past, cs_org_users]);

	const update_column_visibility_json = (column_name, value) => {
		let a = JSON.parse(JSON.stringify(column_visibility_json))
		a[column_name] = value
		set_column_visibility_json(a)
	}

	const column_selector = (
		<div className="p-3" style={{ color: '#323338', display:'flex', flexDirection:'column', height:'380px' }}>
			<div>
				<div className="mb-3" style={{ color: '#A7A8B2', color:'black', fontSize:'15px'}}>Cutomize Columns</div>
				<div className="flex_property justify-between mb-3">
					<ISearch style_outer={{width:'300px'}} style_inner={{width:'300px'}} search_text={column_search_text} set_search_text={set_column_search_text} list={columns} set_list={set_searched_columns} search_parameters={['column_name']}/>
				</div>
				<hr className='mb-3 mt-0' />
			</div>
			<div style={{flex:1, overflow:'auto'}}>
			{
				searched_columns.map(column => (
					<div className="flex_property justify-between" style={{marginBottom:'12px'}}>
						<div className="flex_property">
							<Checkbox checked={column_visibility_json[column.column_name]} onClick={() => {update_column_visibility_json(column.column_name, !column_visibility_json[column.column_name])}}>
								<div>{column.column_name}</div>
							</Checkbox>
						</div>
					</div>
				))
			}
			</div>
		</div>
	)

	// Define toggle_filter_modal function
	const toggle_filter_modal = () => {
		set_show_filter_modal(!show_filter_modal);
	};
	
	// Define trigger_churn_remark_modal function
	const trigger_churn_remark_modal = (store) => () => {
		set_churn_modal_org_selected(store);
		set_show_churn_remark_modal(true);
	};
	
	// Define usage_change function to calculate percentage change
	const usage_change = useCallback((org_id) => {
		try {
			if (mixpanel_org_level_events && mixpanel_org_level_events_past && org_id && 
				mixpanel_org_level_events[org_id] && mixpanel_org_level_events_past[org_id] && 
				selected_usage_events.length) {
				const current_usage = selected_usage_events.reduce((final, event) => 
					mixpanel_org_level_events[org_id][event.value] ? 
					final + mixpanel_org_level_events[org_id][event.value] : final, 0);
				
				const past_usage = selected_usage_events.reduce((final, event) => 
					mixpanel_org_level_events_past[org_id][event.value] ? 
					final + mixpanel_org_level_events_past[org_id][event.value] : final, 0);
				
				if (current_usage === 0 && past_usage === 0) return "0%";
				if (past_usage === 0) return "100%";
				
				const change = ((current_usage - past_usage) / past_usage) * 100;
				return change.toFixed(0) + "%";
			}
			return "0%";
		} catch (e) {
			console.error("Error calculating usage change:", e);
			return "0%";
		}
	}, [mixpanel_org_level_events, mixpanel_org_level_events_past, selected_usage_events]);
	
	// Define refresh_data function
	const refresh_data = useCallback(() => {
		if (all_stores && all_stores.length) {
			const filtered_stores = all_stores.filter(x => x.churned);
			set_original_stores(filtered_stores);
			set_stores(filtered_stores);
		}
	}, [all_stores]);
	
	// Define fetch_cs_org_users function
	const fetch_cs_org_users = useCallback(async () => {
		try {
			const response = await general_fetch({ url: 'customer_success_executive/get' });
			if (response && response.length) {
				const formatted_cs_executives = response.map(cs_exec => {
					const matching_user = cs_org_users.find(user => user.id === cs_exec.user_id);
					return {
						...cs_exec,
						first_name: matching_user ? matching_user.first_name : '',
						email: matching_user ? matching_user.email : '',
						pe: Boolean(cs_exec.pe)
					};
				});
				set_cs_executives(formatted_cs_executives);
				set_edited_cs_org_users(cs_org_users);
			}
		} catch (error) {
			console.error('Error fetching CS executives:', error);
		}
	}, [cs_org_users]);
	
	// Define store_filler for loading state
	const store_filler = (
		<div className="text-center p-5">
			<div className="spinner-border text-primary" role="status">
				<span className="sr-only">Loading...</span>
			</div>
			<p className="mt-2">Loading organizations...</p>
		</div>
	);

	return (
		<>
			<OrgFilterModal
			  open={show_filter_modal}
			  toggle = {toggle_filter_modal}
			  premium_filter = {premium_filter}
			  set_premium_filter = {set_premium_filter}
			  enterprise_filter = {enterprise_filter}
			  set_enterprise_filter = {set_enterprise_filter}
			  suspended_filter = {suspended_filter}
			  set_suspended_filter = {set_suspended_filter}
			  internal_filter = {internal_filter}
			  set_internal_filter = {set_internal_filter}
              mes_expansion_filter = {mes_expansion_filter}
              set_mes_expansion_filter = {set_mes_expansion_filter}
			  selected_cses={selected_cses}
			  set_selected_cses = {set_selected_cses}
			  pe_filter={pe_filter}
			  set_pe_filter = {set_pe_filter}
			  se_filter={se_filter}
			  set_se_filter = {set_se_filter}
			  onboarding_filter = {onboarding_filter}
			  set_onboarding_filter = {set_onboarding_filter}
			  churn_date_filter = {churn_date_filter}
			  set_churn_date_filter = {set_churn_date_filter}
			  churn_date_from={churn_date_from}
			  set_churn_date_from={churn_date_from}
			  churn_date_to={churn_date_to}
			  set_churn_date_to={churn_date_to}
			  cs_org_users={edited_cs_org_users}
			  cs_executives = {cs_executives}
			  set_filter_active = {set_filter_active}
			  responsiveness_filter = {responsiveness_filter}
			  set_responsiveness_filter = {set_responsiveness_filter} 
			  selected_add_ons = {selected_add_ons}
			  set_selected_add_ons = {set_selected_add_ons}
			  selected_domains={selected_domains}
			  set_selected_domains={set_selected_domains}
			  all_stores = {all_stores.filter(o => o.churned)}
			  payment_cycle_filter={payment_cycle_filter}
			  set_payment_cycle_filter={set_payment_cycle_filter}
			  filter_fn = {(a,b,c,d,e,f,g,h,i, j, k, l, m, n, o, p, q) => filter_fn(search_text, original_stores, set_stores, selectedNavItem, all_new_renewed_filter, a, b, c, d, e, f, g, h, i, j, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, churn_date_filter, churn_date_from, churn_date_to, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, k, l, m, n, o, p, q)}
		  />
		  <DateRangeModal
			  open={show_date_range}
			  toggle={() => set_show_date_range(false)}
			  dateRange = {[{startDate: churn_date_from, endDate: churn_date_to, key: 'selection'}]}
			  setRange={(x, y) => {set_churn_date_from(x); set_churn_date_to(y); set_churn_date_filter('custom')}}
			  filter_fn = {(x, y) => filter_fn(search_text, original_stores, set_stores, selectedNavItem, all_new_renewed_filter, enterprise_filter, suspended_filter, internal_filter, mes_expansion_filter, selected_cses, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, 'custom', x, y, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, payment_cycle_filter, undefined, pe_filter)}
		  />
		  <DateRangeModal 
			  open={show_usage_date_range}
			  toggle={() => set_show_usage_date_range(false)}
			  dateRange = {[{startDate: usage_start_time, endDate: usage_end_time, key:'selection'}]}
			  setRange={(x,y) => {set_usage_start_time(x); set_usage_end_time(y); set_usage_duration_filter('custom')}}
			  filter_fn={(x,y) => fetch_mix_panel_data(x, y, set_mixpanel_org_level_events, set_mixpanel_org_level_events_past, set_fetching_usage)}
		  />
		<div className="flex_property" style={{position: 'absolute', top: '24px', left: '125px', zIndex: 50}}>
			{count_orgs_without_comment > 0 && (
				<div className="alert alert-danger" style={{fontSize: '10px', padding: '5px', margin: '5px', borderRadius: '5px', textAlign: 'center'}}>
					<span style={{fontSize: 12}}><b>{count_orgs_without_comment}</b></span> <br/>Churn Comments missing
				</div>
			)}
			{count_orgs_without_category > 0 && (
				<div className="alert alert-danger" style={{fontSize: '10px', padding: '5px', margin: '5px', borderRadius: '5px', textAlign: 'center'}}>
					<span style={{fontSize: 12}}><b>{count_orgs_without_category}</b></span> <br/>Churn Category missing
				</div>
			)}
			{count_orgs_without_reachout_date > 0 && (
				<div className="alert alert-danger" style={{fontSize: '10px', padding: '5px', margin: '5px', borderRadius: '5px', textAlign: 'center'}}>
					<span style={{fontSize: 12}}><b>{count_orgs_without_reachout_date}</b></span> <br/>Churn R/o Date missing
				</div>
			)}
		</div>
		  <Container fluid style={{overflow:'hidden'}}>
			<Row>
			  <div className="col px-2">
				<Card className="shadow" style={{height:'100vh', borderRadius:'0px'}}>
				  <CardHeader id='orgs_page_header' className="border-0 p-0 px-1 pb-2">
					<Row style={{...styles.header_row, justifyContent:'space-between'}} className='pl-2 pr-4 mt-4'>
						<Nav pills style={{paddingBottom: 5, marginTop: 4}}>
							<NavItem>
								<NavLink href='#' active={selectedNavItem === 4} onClick={() => {set_selectedNavItem(4);set_current_page(1)}}><b>Churned</b> </NavLink>
							</NavItem>
						</Nav>
						<div className="flex_center">
							<ISearch search_text={search_text} set_search_text={set_search_text} placeholder={'Search by Name, Id, Address'} style_outer={{width:'250px'}} />
							<div className='flex_center pr-2 pl-2 pt-1 pb-1 cp mr-2' style={{borderRadius:'6px', border:'1px solid gray', color:filter_active ? '#0078ff' : '', borderColor: filter_active ? '#0078ff' : 'gray', backgroundColor: filter_active ? '#EFF6FF' : ""}} onClick={() => toggle_filter_modal()}>
								<div className='mr-3' style={{fontSize:'14px'}}>Filter</div>
								{filter_active ? <i className='fa fa-filter' style={{}} /> : <img src="/filter_icon_outline.svg" />}
							</div>
								<div className="flex_center cp py-1 px-2" style={{ border:'1px solid #0078ff', borderRadius:'6px', color:'#0078ff', fontSize:'14px'}} onClick={download_overview_csv}>Export Results</div>
                                        <Tooltip
                                            title={column_selector}
                                            color='white'
                                            placement='left'
                                            trigger={'click'}
                                            overlayStyle={{borderRadius:'16px', marginRight:'30px', maxWidth:'unset'}}
                                            overlayInnerStyle={{ maxHeight:'380px', overflow:'hidden', marginBottom:'10px'}}
                                            style={{borderRadius:'16px', width:'400px'}}
                                            fresh={true}
                                            open={show_column_selector}
                                            onOpenChange={() => set_show_column_selector(!show_column_selector)}
                                        >
                                            <div className='flex_center p-2' style={{}}>
                                                <i className='fa fa-cog cp' onClick={() => set_show_column_selector(!show_column_selector)} style={{fontSize:'18px'}} />
                                            </div>  
                                        </Tooltip>
						</div>
					</Row>
					<Row className='mt-4 px-4 flex_center' style={{justifyContent:'space-between', fontSize:'14px', padding:'0px 0px 0px 10px'}}>
							<div className="flex_center" style={{fontSize:'12px'}}>
							  <Select 
								  components={animatedComponents}
								  value={{value:all_new_renewed_filter, label:convert_to_readable(all_new_renewed_filter)}}
								  options={[{value:'all',label:'All'}, {value:'new',label:'New'}, {value:'renewed',label:'Renewed'}]}
								  styles={colourStyles1}
								  onChange={(selectedOptions) => set_all_new_renewed_filter(selectedOptions.value)}
							  />
							  <div className="ml-2">
									<Select
										components={animatedComponents}
										value={{ value: payment_cycle_filter, label: payment_cycle_filter==3 ? 'Quarterly' : (payment_cycle_filter==12 ? 'Annual' : 'All') }}
										options={[{ value: '', label: 'All' }, { value: 3, label: 'Quarterly' }, { value: 12, label: 'Annual' }]}
										styles={colourStyles1}
										onChange={(selectedOptions) => set_payment_cycle_filter(selectedOptions.value)}
									/>
							  </div>
							  <div className="mr-2 ml-2">CS Rep:</div>
							  <Select 
								  // closeMenuOnSelect={false}
								  components={animatedComponents}
								  value = {selected_cses}
								  isMulti
								  options={cs_executives && cs_executives.length ? cs_executives.map(x => {return {value: x.user_id, label: x.first_name}}) : []}
								  styles={colourStyles}
								  onChange={(selectedOptions) => {set_selected_cses(selectedOptions); filter_fn(search_text, original_stores, set_stores, selectedNavItem, all_new_renewed_filter, enterprise_filter, suspended_filter, internal_filter, mes_expansion_filter, selectedOptions, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, churn_date_filter, churn_date_from, churn_date_to, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, payment_cycle_filter, undefined, pe_filter)}}
							  />
							  <div className="mr-2 ml-2">PE:</div>
							  <Select
								  components={animatedComponents}
								  value = {pe_filter}
								  isMulti
								  options={pe_filter_options(cs_executives)}
								  styles={colourStyles}
								  onChange={(selectedOptions) => {set_pe_filter(selectedOptions); filter_fn(search_text, original_stores, set_stores, selectedNavItem, all_new_renewed_filter, enterprise_filter, suspended_filter, internal_filter, mes_expansion_filter, selected_cses, se_filter, onboarding_filter, responsiveness_filter, selected_add_ons, selected_domains, due_date_filter, due_date_from, due_date_to, suspension_date_filter, suspension_date_from, suspension_date_to, churn_date_filter, churn_date_from, churn_date_to, last_billed_date_filter, last_billed_date_from, last_billed_date_to, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, payment_cycle_filter, undefined, selectedOptions)}}
							  />
							  <div style={{fontSize:'14px', color:'purple'}} className="ml-4">Viewing {((current_page - 1) * page_size)+1 +' - '+ Math.min((((current_page - 1) * page_size)+page_size), stores&&stores.length)} of {stores ? stores.length : 0} Orgs</div>
						  </div>
						  <div className="flex_center" style={{fontSize:'12px'}}>
							  <div className="mr-2">Usage Events:</div>
							  {usage_view_mode === 'custom' ? (
								  <Select 
									  components={animatedComponents}
									  value={selected_usage_events}
									  isMulti
									  options={mixpanel_event_types}
									  styles={colourStyles}
									  onChange={(selectedOptions) => set_selected_usage_events(selectedOptions)}
								  />
							  ) : (
								  <div className="ml-2" style={{fontWeight: 'bold'}}>10-Point View</div>
							  )}
							  <div className="ml-3 flex_center">
								  <span className="mr-2">Custom</span>
								  <Switch 
									  checked={usage_view_mode === '10-point'}
									  onChange={() => set_usage_view_mode(usage_view_mode === 'custom' ? '10-point' : 'custom')}
									  size="small"
								  />
								  <span className="ml-2">10-Point</span>
							  </div>
						  </div>
					</Row>
  
					<Row className='mt-4 px-4 flex_center' style={{justifyContent:'space-between', fontSize:'14px', padding:'0px 0px 0px 10px'}}>
						<div className="custom_time_filter">
							<div
								className={`nav-item ${churn_date_filter === '' && 'selected'}`}
								onClick={() => {set_churn_date_filter(''); set_current_page(1)}}
							>
								All
							</div>
							<div
								className={`nav-item ${churn_date_filter === 'today' && 'selected'}`}
								onClick={() => {set_churn_date_filter('today'); set_current_page(1)}}
							>
								Churned Today
							</div>
							<div
								className={`nav-item ${churn_date_filter === 'yesterday' && 'selected'}`}
								onClick={() => {set_churn_date_filter('yesterday'); set_current_page(1)}}
							>
								Churned Yesterday
							</div>
							<div
								className={`nav-item ${churn_date_filter === 'last_7_days' && 'selected'}`}
								onClick={() => {set_churn_date_filter('last_7_days'); set_current_page(1)}}
							>
								Last 7 days
							</div>
							<div
								className={`nav-item ${churn_date_filter === 'last_30_days' && 'selected'}`}
								onClick={() => {set_churn_date_filter('last_30_days'); set_current_page(1)}}
							>
								Last 30 days
							</div>
							<div
								className={`nav-item ${churn_date_filter === 'custom' && 'selected'}`}
								onClick={() => {set_current_page(1); set_show_date_range(true)}}
							>
								{churn_date_filter === 'custom' ? churn_date_from.toDateString().substring(4,10) +  ' - ' + churn_date_to.toDateString().substring(4,10) : 'Select Period'}
								<div style={{position:'absolute', backgroundColor:'white', zIndex:'10', boxShadow:'0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)'}}>
								</div>
							</div>
						</div>
					  	<div className="custom_time_filter">
							<div
								className={`nav-item ${usage_duration_filter === 'today' && 'selected'}`}
								onClick={() => {set_usage_duration_filter('today'); }}
							>
								Usage Today
							</div>
							<div
								className={`nav-item ${usage_duration_filter === 'yesterday' && 'selected'}`}
								onClick={() => {set_usage_duration_filter('yesterday'); }}
							>
								Usage Yesterday
							</div>
							<div
								className={`nav-item ${usage_duration_filter === 'last_7_days' && 'selected'}`}
								onClick={() => {set_usage_duration_filter('last_7_days'); }}
							>
								Last 7 days
							</div>
							<div
								className={`nav-item ${usage_duration_filter === 'last_30_days' && 'selected'}`}
								onClick={() => {set_usage_duration_filter('last_30_days'); }}
							>
								Last 30 days
							</div>
							<div
								className={`nav-item ${usage_duration_filter === 'custom' && 'selected'}`}
								onClick={() => { set_show_usage_date_range(true)}}
							>
								{usage_duration_filter === 'custom' ? usage_start_time.toDateString().substring(4,10) +  ' - ' + usage_end_time.toDateString().substring(4,10) : 'Select Period'}
								<div style={{position:'absolute', backgroundColor:'white', zIndex:'10', boxShadow:'0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)'}}>
								</div>
							</div>
						</div>
					</Row>
				  </CardHeader>
				  {stores ? (
					<ITable style={{fontSize:'13px', whiteSpace:'nowrap'}} style_container={{overflow:'auto', height:'calc(100% - 52px)'}} 
						coloumnSeparated={1} rowSeparated={1} resizable={true} minCellWidth={80} 
						headings={headings} columnWidths={headings && headings.length ? headings.filter(o => column_visibility_json[o.column_name]).map(o => o.columnWidth).join(' ') : 'k'} tableSettings={false}
						column_visibility_json = {column_visibility_json} set_column_visibility_json={set_column_visibility_json} cellHeight={'45px'}
					>
						<ITableBody>
							{
								stores && stores.length ? stores.slice((current_page - 1) * page_size, current_page * page_size).map((org, idx) => {
									let json = TableData(org, idx, current_page, page_size)
									return(
										Object.keys(json).map((key) => (
											<ITableRow className='display_onhover'>
												{column_visibility_json[key]?json[key]:''}
											</ITableRow>
										))
									)
								}):''
							}
						</ITableBody>
					</ITable>
				  ) : store_filler}
				  <Col xs="12" id='paginator' className="flex_center py-2" style={{maxHeight:'52px'}}>
						<TablePagination current_page={current_page} set_current_page={set_current_page} no_of_pages={no_of_pages} page_size={page_size} set_page_size={set_page_size} set_user_selected_page_size={set_user_selected_page_size} fetching_usage={fetching_usage}/>
					</Col>
				</Card>
				<ChurnRemarkModal
					open={show_churn_remark_modal}
					toggle={() => set_show_churn_remark_modal(false)}
					org_info={churn_modal_org_selected}
					refresh_data={() => window.location.reload()}
					// post_ops={refresh_data}
					mode='view'
					set_page_loader={set_page_loader}
				/>
			  </div>
			</Row>
		  </Container>
		</>
	  )

}

export default ChurnedOrgs